<template>
  <nav class="dg-global-breadcrumb">
    <div class="breadcrumbs-sub-wrapper">
      <span
        v-for="(item, index) in breadcrumbItems"
        :key="index"
        class="item-wrapper"
      >
        <template
          v-for="isFinalCrumb in [(breadcrumbItems.length === index + 1)]"
          :key="isFinalCrumb"
        >
          <component
            :is="isFinalCrumb ? 'span' : 'router-link'"
            :to="item.to"
            :class="['item', { current: isFinalCrumb }]"
            :title="item.tooltip"
          >
            <img
              v-if="item.icon"
              :src="item.icon"
              class="icon"
            >
            {{ item.text }}
          </component>
          <span
            v-if="!isFinalCrumb"
            class="divider"
          >/</span>
        </template>
      </span>
    </div>
    <!--
    TODO: Replace the below with this once the new event process works
    <MultiButton label="Create">
      <p @click="onOpneForNewRally">Create New Rally</p>
      <p @click="onOpneForSpecialEvents">Create Special Event</p>
      <p @click="onOpneForQuickEvents">Create Quick Event</p>
    </MultiButton>
    -->
    <router-link
      v-if="$route.name === 'dashboard'"
      to="/start"
      class="dg-multi-button"
      style="text-decoration: none;"
    >
      <button
        class="desktop-button"
        style="display: inline-block; padding-left: 0;"
      >
        <span>Create New Rally</span>
      </button>
    </router-link>
  </nav>
</template>

<script>
  import { mapState } from "vuex";
  import { rallyAttributesIsHub } from "../common";
  import { truncate } from '@/common/utils';
  import MultiButton from "./MultiButton";

  const maxRallyTitleLength = 36

  export default {
    name: "GlobalBreadcrumb",
    components: {
      MultiButton,
    },
    computed: {
      ...mapState("navigation", ["currentChannel", "currentChannels", "currentRally"]),
      breadcrumbItems() {
        const route = this.$route

        // Exit early if you are on the Dashboard
        if ( route.name === 'dashboard' ) {
          return [{ text: route.meta.title }]
        }

        const items = [{ text: "My Rallyhood", to: "/rallies" }]
        const dashboardRoutes = ['feed', 'messaging', 'messaging-sub', 'my-calendar', 'user-settings']

        // Exit early if you are on a Dashboard sub-page
        if ( dashboardRoutes.includes(route.name) ) {
          items.push({
            text: route.meta.title,
            to: route.meta.path,
          })
          return items
        }

        const rally = this.currentRally

        // Exit early if we are not looking at a rally.
        if ( !rally ) {
          return items
        }

        const parentRally = rally.parent
        const isChild = ( parentRally && parentRally.type === 'Standard' && rally['parent-relationship-type'] != 'HiddenOrg' )

        // Append the parent hub if present.
        if ( isChild ) {
          items.push({
            icon: "/icons/hubicon_grey.svg",
            text: truncate(parentRally.title, maxRallyTitleLength),
            to: `/${parentRally.id}`,
            tooltip: (parentRally.title.length > maxRallyTitleLength) ? parentRally.title : null
          })
        }

        const channels = this.currentChannels

        // If the rally has no channels, show the rally
        // crumb without channel decoration and bail before any indexing.
        if ( !Array.isArray(channels) || channels.length === 0 ) {
          items.push({
            icon: "/icons/rallyicon.svg",
            text: truncate(rally.title, maxRallyTitleLength),
            tooltip: (rally.title.length > maxRallyTitleLength) ? rally.title : null
          })
          return items
        }

        const channel = this.currentChannel
        const rallyIconPrefix = rally['is-hub'] ? "hub" : "rally"
        const rallyIconSuffix = channel.isFirstChannel ? "" : "_grey"

        // Append the current rally or hub name.
        items.push({
          icon: `/icons/${rallyIconPrefix}icon${rallyIconSuffix}.svg`,
          text: truncate(rally.title, maxRallyTitleLength),
          to: `/${rally.id}`,
          tooltip: (rally.title.length > maxRallyTitleLength) ? rally.title : null
        })

        // Append the channel name.
        if ( channel && !channel.isFirstChannel ) {
          items.push({text: channel.attributes.name})
        }

        return items
      },
    },
  };
</script>
